export default __webpack_public_path__ + "static/media/031-gift.3073bd39.png";